import React, { useEffect } from "react";
import Typist from "react-typist";
import Container from "react-bootstrap/Container";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

const MainBody = React.forwardRef(
  ({ gradient, title, message1, message2, icons, light }, ref) => {
    const controlsOne = useAnimation();
    const [refOne, inViewOne] = useInView();
    const controlsTwo = useAnimation();
    const [refTwo, inViewTwo] = useInView();

    const headerFade = {
      visible: { opacity: 1, y: 0, transition: { duration: 2 }, delay: "0" },
      hidden: { opacity: 0, y: 10 },
    };
    const appearUp = {
      visible: { opacity: 1, y: 0, transition: { duration: 1 }, delay: "0" },
      hidden: { opacity: 0, y: 10 },
    };

    useEffect(() => {
      if (inViewOne) {
        controlsOne.start("visible");
      } else {
        controlsOne.start("hidden");
      }
      if (inViewTwo) {
        controlsTwo.start("visible");
      } else {
        controlsTwo.start("hidden");
      }
    }, [controlsOne, inViewOne, controlsTwo, inViewTwo]);

    return (
      <Container
        fluid
        id="home"
        style={{
          background: `linear-gradient(136deg,${gradient})`,
          backgroundSize: "1200% 1200%",
        }}
        className="title bg-transparent bgstyle text-light min-vh-100 d-flex align-content-center align-items-center flex-wrap m-0"
      >
        <div id="stars"></div>
        <Container className="text-center">
          <motion.h1
            variants={headerFade}
            initial="hidden"
            animate="visible"
            ref={ref}
            className="display-1"
          >
            {title}
          </motion.h1>
          <Typist className="lead typist" cursor={{ show: false }}>
            {" "}
            <i>{message1}</i>
          </Typist>
          <Typist className="lead typist" cursor={{ show: false }}>
            {" "}
            <b>{message2}</b>
          </Typist>
          <motion.div
            variants={appearUp}
            initial="hidden"
            animate={controlsOne}
            ref={refOne}
            className="p-5"
          >
            {icons.map((icon, index) => (
              <a
                key={`social-icon-${index}`}
                target="_blank"
                rel="noopener noreferrer"
                href={icon.url}
                aria-label={`My ${icon.image.split("-")[1]}`}
              >
                <i className={`fab ${icon.image}  fa-3x socialicons`} />
              </a>
            ))}
          </motion.div>
          <motion.a
            className="btn btn-outline-light btn-lg "
            href="#aboutme"
            role="button"
            variants={appearUp}
            initial="hidden"
            animate={controlsTwo}
            ref={refTwo}
            aria-label="Learn more about me"
          >
            More about me
          </motion.a>
        </Container>
      </Container>
    );
  }
);

export default MainBody;
